import { css } from 'styled-components';

const clickableCursorStyle = css `
    cursor: pointer;
`;
const disabledCursorStyle = css `
    cursor: not-allowed;
`;
const textCursorStyle = css `
    cursor: vertical-text;
`;

export { clickableCursorStyle, disabledCursorStyle, textCursorStyle };
//# sourceMappingURL=cursor.js.map
